"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const qs_1 = require("qs");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const OverviewModalHeader_1 = require("./OverviewModalHeader");
const OverviewModalFooter_1 = require("./OverviewModalFooter");
const OverviewModalBodyContainer_1 = require("./OverviewModalBodyContainer");
const reducers_1 = require("../../../reducers");
const actions_1 = require("../../../actions");
class OverviewComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    componentWillMount() {
        const { campaign, createEditableCampaign } = this.props;
        createEditableCampaign(campaign.id);
    }
    render() {
        const { campaign, device } = this.props;
        if (campaign !== null) {
            return (React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    background: src_1.white,
                    position: 'relative',
                    minHeight: '100%',
                    width: '100%',
                }, id: "overviewComponentRoot" },
                React.createElement(OverviewModalHeader_1.default, { campaignId: campaign.id, device: device }),
                React.createElement(OverviewModalBodyContainer_1.default, { device: device, trigger: campaign.trigger, campaignTags: campaign.tags, campaignId: campaign.id }),
                React.createElement(OverviewModalFooter_1.default, { device: device, campaign: campaign })));
        }
        else {
            return React.createElement("div", null, "Campaign Not Found");
        }
    }
}
const mapStateToProps = (state, ownProps) => {
    const { location } = ownProps;
    const { campaignId } = qs_1.parse(location.search.substring(1));
    return {
        campaign: reducers_1.getCampaign(state, campaignId),
        editableCampaign: reducers_1.getEditableCampaign(state),
        editableUIState: reducers_1.getEditableUIState(state),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        createEditableCampaign: (campaignId) => {
            dispatch(actions_1.createEditableCampaign(campaignId));
        },
    };
};
exports.default = react_router_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps)(OverviewComponent));
